import { Layout, labelDefaultMediumStyles } from '@lifebit-ai/lds'
import styled from 'styled-components'

export const StyledContent = styled(Layout.Content)`
  display: flex;
  flex-direction: column;

  & > div {
    gap: ${({ theme }) => theme.size.space['04']};
  }
`

export const ButtonsWrapper = styled.div`
  display: inline-flex;
  gap: ${({ theme }) => theme.size.space['03']};
`

export const DetailsCards = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.size.space['04']};
`

export const CardSectionTitle = styled.h3`
  ${labelDefaultMediumStyles}
  color: ${({ theme }) => theme.color.content.main};
  margin: 0;
`
